import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

/**
 * directive: v-responseModal
 * value 값의 true/false 여부로 해당 element를 노출시키고, 나머지 영역은 스크롤을 중지시킨다.
 * @type {{bind: bind, update: update}}
 */
export const responseModal = {
    bind(el) {
        el.style.display = 'none';
    },
    update(el, binding) {
        if (binding.oldValue === binding.value) {
            return;
        }

        if (binding.value === true) {
            disableBodyScroll(el);
            el.style.display='';

        } else {
            enableBodyScroll(el);

            /* 모바일 환경에서 body태그 style overflow 수정이 바로 적용이 안되는 버그로 인한 설정 */
            setTimeout(function () {
                el.style.display='none';
            }, 2);

        }
    }
};